export default __webpack_public_path__ + "static/media/EM0460.34I-22657_-15128_0.9c180a3d.jpg";